import React, { useEffect, useState } from 'react'
import { Button, Form, Input, Pagination, Row, Table } from 'antd'
import { useRecoilState } from 'recoil'
import { userState } from '../../store/user'
import promotionApi from '../../api/promotion.api'
import styles from '../../styles/promotion.module.scss'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'

const CouponListPage = () => {
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(false)
  const [form] = Form.useForm()
  const navigate = useNavigate()

  const [searchOptions, setSearchOptions] = useState({
    couponId: '',
    couponTitle: '',
  })
  const [orderType, setOrderType] = useState('updatedAt')
  const [orderBy, setOrderBy] = useState('desc')
  const [totalSize, setTotalSize] = useState(0)
  const [currentPageNumber, setCurrentPageNumber] = useState(1)
  const [offset, setOffset] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [couponList, setCouponList] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  // const [selectedRows, setSelectedRows] = useState([]);
  const [btnStatus, setBtnStatus] = useState(0) // 0: disabled, 1: 다운로드 불가능, 2: 다운로드 가능
  const [availableBtnStatus, setAvailableBtnStatus] = useState(0) // 0: disabled, 1: 사용 불가능, 2: 사용 가능

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      if (selectedRows?.length > 0) {
        const possibleResult = selectedRows.every(
          (row) => row.couponPublishAvailable,
        )
        const availableResult = selectedRows.every(
          (row) => row.couponIsAvailable,
        )
        if (possibleResult) {
          setBtnStatus(1)
        } else {
          const impossibleResult = selectedRows.every(
            (row) => !row.couponPublishAvailable,
          )
          if (impossibleResult) {
            setBtnStatus(2)
          } else {
            setBtnStatus(0)
          }
        }
        if (availableResult) {
          setAvailableBtnStatus(1)
        } else {
          const unavailableResult = selectedRows.every(
            (row) => !row.couponIsAvailable,
          )
          if (unavailableResult) {
            setAvailableBtnStatus(2)
          } else {
            setBtnStatus(0)
          }
        }
      }
      setSelectedRowKeys(selectedRowKeys)
    },
  }

  const columns = [
    {
      title: '쿠폰번호',
      width: 150,
      dataIndex: 'couponId',
      key: 'couponId',
      fixed: 'left',
      ellipsis: true,
    },
    {
      title: '쿠폰 종류',
      width: 120,
      dataIndex: 'couponType',
      key: 'couponType',
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value === 'CATEGORY') {
          return <span>카테고리</span>
        } else if (value === 'BRAND') {
          return <span>브랜드</span>
        } else if (value === 'PRODUCT') {
          return <span>상품</span>
        }
        // else if (value === 'related_product') {
        //   return <span>연관상품</span>
        // }
        // else if (value === 'event') {
        //   return <span>이벤트</span>
        // }
        else if (value === 'ALL') {
          return <span>전체 상품 대상 이벤트</span>
        } else {
          return <span>-</span>
        }
      },
    },
    {
      title: '쿠폰명',
      width: 120,
      dataIndex: 'couponTitle',
      key: 'couponTitle',
      ellipsis: true,
    },
    {
      title: '할인',
      width: 50,
      dataIndex: 'couponScore',
      key: 'couponScore',
      ellipsis: true,
      render: (value, record) => {
        if (record.couponScoreType === 'WON') {
          return <span>{value}원</span>
        } else {
          return <span>{value}%</span>
        }
      },
    },
    {
      title: '사용기간',
      width: 280,
      // dataIndex: 'coupon_duration',
      // key: 'coupon_duration',
      ellipsis: true,
      render: (value, recode) => {
        if (recode.couponFrom !== null) {
          const startDate = dayjs(recode.couponFrom).format('YYYY-MM-DD HH:mm')
          if (recode.couponTo !== null) {
            const endDate = dayjs(recode.couponTo).format('YYYY-MM-DD HH:mm')
            return (
              <span>
                {startDate} ~ {endDate}
              </span>
            )
          } else {
            return <span>{startDate} ~ </span>
          }
        } else {
          return <span>-</span>
        }
      },
    },
    // {
    //   title: '발급수',
    //   width: 90,
    //   dataIndex: 'coupon_usage_number',
    //   key: 'coupon_usage_number',
    //   ellipsis: true,
    //   // sorter: (a, b) => {},
    // },
    {
      title: '다운로드 가능 여부',
      width: 110,
      dataIndex: 'couponPublishAvailable',
      key: 'couponPublishAvailable',
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value) {
          return <span>다운로드 가능</span>
        } else {
          return <span>다운로드 불가능</span>
        }
      },
    },
    {
      title: '사용 가능 여부',
      width: 110,
      dataIndex: 'couponIsAvailable',
      key: 'couponIsAvailable',
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value) {
          return <span>사용 가능</span>
        } else {
          return <span>사용 불가능</span>
        }
      },
    },
    {
      title: '최종수정일',
      width: 140,
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = dayjs(value).format('YYYY.MM.DD. HH:mm')
          return <span>{date}</span>
        }
      },
    },
    // {
    //   title: '수정자',
    //   width: 90,
    //   dataIndex: 'updated_by_name',
    //   key: 'updated_by_name',
    //   ellipsis: true
    // },
    {
      title: '생성일',
      width: 140,
      dataIndex: 'createdAt',
      key: 'createdAt',
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = dayjs(value).format('YYYY.MM.DD. HH:mm')
          return <span>{date}</span>
        }
      },
    },
    // {
    //   title: '생성자',
    //   width: 90,
    //   dataIndex: 'created_by_name',
    //   key: 'created_by_name',
    //   ellipsis: true
    // },
  ]

  useEffect(() => {
    getReadCouponList()
  }, [])

  useEffect(() => {
    getReadCouponList()
  }, [offset, pageSize, orderType, orderBy])

  useEffect(() => {
    if (selectedRowKeys?.length === 0) {
      setBtnStatus(0)
      setAvailableBtnStatus(0)
    }
  }, [selectedRowKeys])

  const getReadCouponList = async (type = '') => {
    setIsLoading(true)
    try {
      let param
      if (type === 'initial') {
        param = {
          offset: 0,
          pageSize: 10,
          couponId: searchOptions.couponId,
          couponTitle: searchOptions.couponTitle,
          orderType: orderType,
          orderBy: orderBy,
        }
      } else {
        param = {
          offset: offset,
          pageSize: pageSize,
          couponId: searchOptions.couponId,
          couponTitle: searchOptions.couponTitle,
          orderType: orderType,
          orderBy: orderBy,
        }
      }
      const res = await promotionApi.readCouponList(param, user.id)
      if (res.data.code === 200) {
        setCouponList(res.data.result.couponDTOList)
        setTotalSize(res.data.result.totalCnt)
      } else {
        alert('정상적인 요청이 아닙니다.')
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('couponList read error', error)
    }
  }

  /**
   * Form value change handle
   * @param changedValues : 변경 이벤트가 발생하는 값
   * @param allValues : Form의 모든 값
   */
  const handleFormValuesChange = (changedValues, allValues) => {
    setSearchOptions({ ...searchOptions, ...changedValues })
  }

  /**
   * 다운로드 가능 여부 수정 버튼 click
   */
  const handleEditBtnClick = async () => {
    setIsLoading(true)
    try {
      let newEditCoupon = {
        editList: selectedRowKeys,
        editKey: 'coupon_publish_available',
      }
      if (btnStatus === 2) {
        newEditCoupon['editValue'] = true
      } else if (btnStatus === 1) {
        newEditCoupon['editValue'] = false
      }
      const res = await promotionApi.editCoupon(newEditCoupon, user.id)
      if (res.data.code === 200) {
        alert('해당 내용이 성공적으로 수정되었습니다.')
        getReadCouponList()
        setSelectedRowKeys([])
      } else if (res.data.code === 999) {
        alert(res.data.msg)
      } else {
        alert(
          '선택한 쿠폰들의 다운로드 가능 여부 상태값 수정에 실패하였습니다. 다시 시도하시거나 관리자에게 문의하시길 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('handleEditBtnClick edit error', error)
    }
  }

  /**
   * 사용 가능 여부 수정 버튼 click
   */
  const handleEditAvailableBtnClick = async () => {
    setIsLoading(true)
    try {
      let newEditCoupon = {
        editList: selectedRowKeys,
        editKey: 'coupon_is_available',
      }
      if (availableBtnStatus === 2) {
        newEditCoupon['editValue'] = true
      } else if (availableBtnStatus === 1) {
        newEditCoupon['editValue'] = false
      }
      const res = await promotionApi.editCoupon(newEditCoupon, user.id)
      if (res.data.code === 200) {
        alert('해당 내용이 성공적으로 수정되었습니다.')
        getReadCouponList()
        setSelectedRowKeys([])
      } else if (res.data.code === 999) {
        alert(res.data.msg)
      } else {
        alert(
          '선택한 쿠폰들의 사용 가능 여부 상태값 수정에 실패하였습니다. 다시 시도하시거나 관리자에게 문의하시길 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('handleEditAvailableBtnClick edit error', error)
    }
  }

  const handleSearch = () => {
    setOffset(0)
    setPageSize(10)
    setCurrentPageNumber(1)
    getReadCouponList('initial')
  }

  const tableOnChange = (pagination, filters, sorter, extra) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === 'descend') {
          setOrderBy('desc')
        } else if (sorter.order === 'ascend') {
          setOrderBy('asc')
        }
        setOrderType(sorter.field)
      } else {
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
        setOrderType('updatedAt')
        setOrderBy('desc')
      }
    }
  }

  const handleRowEvent = (record) => {
    return {
      onClick: (_) => {
        navigate(`/coupon/register/${record.id}`)
      },
    }
  }

  /**
   * page 넘김
   * @param pageNumber
   */
  const handleChangePagination = (pageNumber) => {
    const offset = (pageNumber - 1) * pageSize
    setCurrentPageNumber(pageNumber)
    setOffset(offset)
  }

  /**
   * pageSize 변경 handler
   * @param current
   * @param pageSize
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize)
    setOffset(0)
    setCurrentPageNumber(1)
  }

  return (
    <div className={`${styles.contentPage}`} style={{ margin: 24 }}>
      <Form
        form={form}
        onValuesChange={handleFormValuesChange}
        onFinish={handleSearch}
        labelCol={{ span: 2 }}
        wrapperCol={{ span: 10 }}
      >
        <Form.Item
          label="쿠폰번호"
          name="couponId"
          colon={false}
          labelAlign={'left'}
        >
          <Input placeholder="" onPressEnter={handleSearch} />
        </Form.Item>
        <Form.Item
          label="쿠폰명"
          name="couponTitle"
          colon={false}
          labelAlign={'left'}
        >
          <Input placeholder="" onPressEnter={handleSearch} />
        </Form.Item>
        <Form.Item
          className={`${styles['coupon-search-btn-wrap']}`}
          wrapperCol={{ span: 24 }}
        >
          <Button
            type="primary"
            className="coupon-search-btn"
            onClick={handleSearch}
          >
            검색
          </Button>
        </Form.Item>
      </Form>

      <div className={`${styles['coupon-table-header-buttons-wrap']}`}>
        <Row>
          <Button
            className={`${styles['coupon-table-header-btn']}`}
            type="primary"
            disabled={btnStatus === 0}
            danger={btnStatus === 1}
            onClick={handleEditBtnClick}
          >
            {btnStatus === 2 ? '다운로드 가능' : '다운로드 불가능'}
          </Button>
          <Button
            className={`${styles['coupon-table-header-btn']}`}
            type="primary"
            disabled={availableBtnStatus === 0}
            danger={availableBtnStatus === 1}
            onClick={handleEditAvailableBtnClick}
            style={{ marginLeft: 10 }}
          >
            {availableBtnStatus === 2 ? '사용 가능' : '사용 불가능'}
          </Button>
        </Row>
        <div style={{ paddingTop: '5px' }}>
          Total : {totalSize.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        </div>
      </div>

      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={couponList}
        loading={isLoading}
        bordered
        size="middle"
        rowKey="id"
        rowClassName="coupon-table-row"
        scroll={{ x: 'max-content' }}
        tableLayout={'auto'}
        onRow={handleRowEvent}
        onChange={tableOnChange}
        pagination={false}
      />

      <Pagination
        showQuickJumper
        showSizeChanger
        total={totalSize}
        current={currentPageNumber}
        onShowSizeChange={pageSizeChange}
        onChange={handleChangePagination}
        align={'end'}
        style={{ marginTop: 20 }}
      />
    </div>
  )
}

export default CouponListPage
